import { render, staticRenderFns } from "./bottomPop.vue?vue&type=template&id=1d8a447c&scoped=true&"
import script from "./bottomPop.vue?vue&type=script&lang=js&"
export * from "./bottomPop.vue?vue&type=script&lang=js&"
import style0 from "./bottomPop.vue?vue&type=style&index=0&id=1d8a447c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8a447c",
  null
  
)

export default component.exports